import React, { useEffect } from "react";
import SEO from "../Components/Common/SEO";
import { useTranslation } from "react-i18next";

const PrivacyCompliance = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    return (
        <>
            <SEO title={t("seo.title")} description={t("seo.description")} />

            <div className="min-h-screen  from-zinc-900 via-zinc-900  pt-16">
                <main className="max-w-4xl mx-auto px-4 py-16">
                    <h1 className="text-3xl font-bold text-zinc-100 mb-8">
                        {t("header.noCustody")}
                    </h1>

                    {/* Platform Purpose */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.platformPurpose.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.platformPurpose.paragraph1")}
                            </p>
                            <p className="text-zinc-300">
                                {t("section.platformPurpose.paragraph2")}
                            </p>
                        </div>
                    </section>

                    {/* Non-Custodial Operations */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.nonCustodialOperations.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.nonCustodialOperations.paragraph")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.nonCustodialOperations.listItem1")}</li>
                                <li>{t("section.nonCustodialOperations.listItem2")}</li>
                                <li>{t("section.nonCustodialOperations.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Data Collection */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.dataCollection.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">{t("section.dataCollection.paragraph")}</p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.dataCollection.listItem1")}</li>
                                <li>{t("section.dataCollection.listItem2")}</li>
                                <li>{t("section.dataCollection.listItem3")}</li>
                                <li>{t("section.dataCollection.listItem4")}</li>
                            </ul>
                            <p className="text-zinc-300 mt-4">
                                {t("section.dataCollection.howWeHandleData")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.dataCollection.howWeHandleData.listItem1")}</li>
                                <li>{t("section.dataCollection.howWeHandleData.listItem2")}</li>
                                <li>{t("section.dataCollection.howWeHandleData.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* No KYC Requirement */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.noKYCRequirement.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.noKYCRequirement.listItem1")}</li>
                                <li>{t("section.noKYCRequirement.listItem2")}</li>
                                <li>{t("section.noKYCRequirement.listItem3")}</li>
                                <li>{t("section.noKYCRequirement.listItem4")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Cryptocurrency-Only Transactions */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.cryptocurrencyOnlyTransactions.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.cryptocurrencyOnlyTransactions.listItem1")}</li>
                                <li>{t("section.cryptocurrencyOnlyTransactions.listItem2")}</li>
                                <li>{t("section.cryptocurrencyOnlyTransactions.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Decentralized and Transparent */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.decentralizedAndTransparent.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.decentralizedAndTransparent.listItem1")}</li>
                                <li>{t("section.decentralizedAndTransparent.listItem2")}</li>
                                <li>{t("section.decentralizedAndTransparent.listItem3")}</li>
                                <li>{t("section.decentralizedAndTransparent.listItem4")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Delivery of Physical Goods */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.deliveryOfPhysicalGoods.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.deliveryOfPhysicalGoods.paragraph")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.deliveryOfPhysicalGoods.listItem1")}</li>
                                <li>{t("section.deliveryOfPhysicalGoods.listItem2")}</li>
                                <li>{t("section.deliveryOfPhysicalGoods.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Privacy and Data Protection */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.privacyAndDataProtection.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.privacyAndDataProtection.listItem1")}</li>
                                <li>{t("section.privacyAndDataProtection.listItem2")}</li>
                                <li>{t("section.privacyAndDataProtection.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* User Responsibility */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.userResponsibility.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.userResponsibility.paragraph")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.userResponsibility.listItem1")}</li>
                                <li>{t("section.userResponsibility.listItem2")}</li>
                                <li>{t("section.userResponsibility.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Disclaimer of Liability */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.disclaimerOfLiability.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.disclaimerOfLiability.paragraph")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("section.disclaimerOfLiability.listItem1")}</li>
                                <li>{t("section.disclaimerOfLiability.listItem2")}</li>
                                <li>{t("section.disclaimerOfLiability.listItem3")}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Future Adjustments */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-amber-500 mb-4">
                            {t("section.futureAdjustments.title")}
                        </h2>
                        <div className="prose prose-invert">
                            <p className="text-zinc-300">
                                {t("section.futureAdjustments.paragraph")}
                            </p>
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
};

export default PrivacyCompliance;
